<script>
    import R, {LOADER} from "../lib/requests";
    import {PASSWORD_TIP} from "../lib/constants";
    import PasswordControl from "../components/controls/PasswordControl.svelte";
    import Prompt from "../components/pages/Prompt.svelte";
    import {setFocusTo} from "../lib/lib";
    import Alert from "../stores/alerts";

    export let afm;

    let account = {
        lastname: '',
        firstname: '',
        email: '',
        password: '',
        phone1: '',
        mobile: '',
        afm,
    }

    // let account = {
    //     lastname: 'Νικολουδάκης',
    //     firstname: 'Ζαχαρίας',
    //     email: 'harrys@wise.gr',
    //     password: 'q44g972fpd',
    //     phone1: '2815106377',
    //     mobile: '6932394558',
    //     afm,
    // }

    let error = null;
    let completed = false;

    const submit = () => {
        const onSuccess = result => {
            completed = true;
        }

        const onFailure = err => {
            let field = null;
            let message = null;
            if (err.code && err.message) {
                if (err.params && err.params.field && err.params.field === 'password') {
                    message = PASSWORD_TIP;
                } else {
                    message = err.message;
                }
                field = err.params && err.params.field ? err.params.field : null;
            } else {
                message = "Παρουσιάστηκε κάποιο πρόβλημα κατά την δημιουργία του λογαριασμού σας.";
            }

            Alert.warning("Δημιουργία Λογαριασμού", message, () => {
                if (field) {
                    setFocusTo(field);
                }
            });
        };

        let data = {
            action: 'create-account',
            account,
        }

        R.handle(R.action.request, data, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

{#if !completed}
    <form on:submit|preventDefault|stopPropagation="{ submit }">
        <div class="row">
            <div class="col-xl-4">
                <legend>Στοιχεία Μέλους</legend>
                <div class="form-group">
                    <label>Επίθετο</label>
                    <input type="text" class="form-control" id="lastname" bind:value="{ account.lastname }" required>
                </div>
                <div class="form-group">
                    <label>Όνομα</label>
                    <input type="text" class="form-control" id="firstname" bind:value="{ account.firstname }" required>
                </div>
                <div class="form-group">
                    <label>Τηλέφωνο</label>
                    <input type="tel" class="form-control" id="phone" bind:value="{ account.phone1 }">
                </div>
                <div class="form-group">
                    <label>Κινητό</label>
                    <input type="tel" class="form-control" id="mobile" bind:value="{ account.mobile }" required>
                </div>
                <div class="form-group">
                    <label>ΑΦΜ</label>
                    <div class="form-control-data">{ account.afm }</div>
                </div>
            </div>
            <div class="col-xl-4">
                <legend>Στοιχεία Λογαριασμού</legend>
                <div class="form-group">
                    <label>Email</label>
                    <input type="email" class="form-control" id="email" bind:value="{ account.email }" required>
                </div>
                <div class="form-group">
                    <label>Κωδικός</label>
                    <PasswordControl id="password" bind:value="{ account.password }"/>
                    <p class="small text-gray mt-2">
                        { PASSWORD_TIP }
                    </p>
                </div>
                {#if error}
                    <div class="alert alert-danger">
                        {@html nl2br(error) }
                    </div>
                {/if}
            </div>
        </div>
        <div class="row">
            <div class="col-xl-4">
            </div>
            <div class="col-xl-4">
                <button class="btn btn-primary btn-block">Δημιουργία λογαριασμού</button>
            </div>
        </div>
    </form>
{:else}
    <Prompt message="Σας έχει σταλεί μήνυμα στο ηλεκτρονικό σας ταχυδρομείο με οδηγίες για την ολοκλήρωση της εγγραφής σας.|Αν δεν βρείτε το μήνυμα στα εισερχόμενά σας ελέγξτε τον φάκελο «Ανεπιθύμητα»."/>
{/if}